import type { Dayjs } from 'dayjs'

import { getIsSubscribedTherapistAndService } from '@/legacy-src/hooks/useHasValidSubscription'
import useSubscription from '@/legacy-src/hooks/useSubscription/useSubscription'
import type { ServiceType } from '@/legacy-src/types/GeneralStateType'
import type { TherapistType } from '@/legacy-src/types/TherapistStateType'
import { dateToMonthYear } from '@/legacy-src/utilities/date'

import type { ClientBookingSubscriptionStatusMessageProps } from '@/src/domains/client-booking/components/ClientBookingSubscriptionStatus/ClientBookingSubscriptionStatusMessage'

interface UseClientBookingSubscriptionStatusLegacyParams {
  month: Dayjs
  therapist: TherapistType
  service: ServiceType
}

export const useClientBookingSubscriptionStatusLegacy = ({
  month,
  therapist,
  service,
}: UseClientBookingSubscriptionStatusLegacyParams): ClientBookingSubscriptionStatusMessageProps | null => {
  const { getSubscription, getFreeSubscriptionEvents } = useSubscription()

  const monthYear = dateToMonthYear(month)
  const subscription = getSubscription(monthYear)

  if (!subscription) {
    return null
  }

  const isSubscribedTherapistAndService = getIsSubscribedTherapistAndService(therapist, service, subscription)
  const price = therapist.prices?.find(({ serviceId }) => serviceId === service.id)?.price

  if (!isSubscribedTherapistAndService && price !== subscription.initPrice) {
    return null
  }

  return { month: month.format('MMMM'), freeEventsLeft: getFreeSubscriptionEvents(monthYear) }
}
